import { createSlice } from '@reduxjs/toolkit';
import { ReceivingDetailStateType } from 'src/types/receivingDetail';

const initialState: ReceivingDetailStateType = {
    data: null,
    changelog: null,
    loading: false,
    error: false,
};
export const receivingDetailSlice = createSlice({
    name: 'receivingDetail',
    initialState,
    reducers: {
        getReceivingDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getReceivingDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.changelog = null;
            state.loading = false;
        },
        getReceivingDetailFetchFailure: (state, action) => {
            state.data = null;
            state.changelog = null;
            state.loading = false;
            state.error = true;
        },
        getReceivingDetailChangelogFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getReceivingDetailChangelogFetchSuccess: (state, action) => {
            state.changelog = action.payload.data;
            state.loading = false;
        },
        getReceivingDetailChangelogFetchFailure: (state, action) => {
            state.changelog = null;
            state.loading = false;
            state.error = true;
        },
        createReceivingDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createReceivingDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.changelog = null;
        },
        createReceivingDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
            state.changelog = null;
        },
        updateReceivingDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateReceivingDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.changelog = null;
        },
        updateReceivingDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
            state.changelog = null;
        },
        patchReceivingDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        patchReceivingDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.changelog = null;
        },
        patchReceivingDetailFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
            state.changelog = null;
        },
        editReceivingDetailEshopNoteFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        editReceivingDetailEshopNoteFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.changelog = null;
        },
        editReceivingDetailEshopNoteFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
            state.changelog = null;
        },
        setReceivingDetailData: (state, action) => {
            state.data = action.payload;
        },
        clearReceivingDetail: () => initialState,
    },
});

export const {
    getReceivingDetailFetch,
    getReceivingDetailFetchSuccess,
    getReceivingDetailFetchFailure,
    getReceivingDetailChangelogFetch,
    getReceivingDetailChangelogFetchSuccess,
    getReceivingDetailChangelogFetchFailure,
    createReceivingDetailFetch,
    createReceivingDetailFetchSuccess,
    createReceivingDetailFetchFailure,
    updateReceivingDetailFetch,
    updateReceivingDetailFetchSuccess,
    updateReceivingDetailFetchFailure,
    patchReceivingDetailFetch,
    patchReceivingDetailFetchSuccess,
    patchReceivingDetailFetchFailure,
    editReceivingDetailEshopNoteFetch,
    editReceivingDetailEshopNoteFetchSuccess,
    editReceivingDetailEshopNoteFetchFailure,
    setReceivingDetailData,
    clearReceivingDetail,
} = receivingDetailSlice.actions;

export default receivingDetailSlice.reducer;
